export const getFileType = (fileName: string): string => {
  return fileName.split('.').pop()?.toUpperCase() ?? ''
}
